<div class="location">
  <a
    [href]="geoHref | url"
    [target]="geoTarget"
    *ngIf="small; else big"
    class="location__link"
    [title]="'location_get_directions' | t"
  >
    <div class="d-flex align-items-center">
      <span class="location__icon"></span>

      <div class="location__text light text-small">
        <ng-container [ngTemplateOutlet]="text"></ng-container>
      </div>
    </div>
  </a>

  <ng-template #big>
    <a
      [href]="geoHref | url"
      [target]="geoTarget"
      class="location__link"
      [title]="'location_get_directions' | t"
    >
      <div class="location--big d-flex align-items-center">
        <span class="location__icon"></span>
        <div class="d-grid">
          <div class="text-small col-gray-500">
            {{ "location" | t }}
          </div>

          <div class="location__text dark bold text-small">
            <ng-container [ngTemplateOutlet]="text"></ng-container>
          </div>
        </div>
      </div>
    </a>
  </ng-template>

  <ng-template #text>
    <span *ngFor="let part of locationParts; let i = index"
      ><span *ngIf="i !== 0"> &bull; </span>{{ part }}</span
    >
  </ng-template>
</div>
